export default __webpack_public_path__ + "static/media/vuurKlein.5046df75.jpg";